import React, { useState, useEffect } from 'react';
import { IconButton, Tooltip, Collapse } from '@mui/material';
import FeedbackIcon from '@mui/icons-material/Feedback';
import CloseIcon from '@mui/icons-material/Close';
import '../../styles/FeedbackButton.css';

/**
 * Floating Feedback Button
 * Fixed position on right side of screen (vertically centered)
 * Can be hidden/shown with state persisted to localStorage
 */
const FeedbackButton = ({ onOpenModal }) => {
  const [isHidden, setIsHidden] = useState(false);

  // Load hidden state from localStorage on mount
  useEffect(() => {
    const hiddenState = localStorage.getItem('feedbackButtonHidden');
    if (hiddenState === 'true') {
      setIsHidden(true);
    }
  }, []);

  const handleToggleVisibility = () => {
    const newState = !isHidden;
    setIsHidden(newState);
    localStorage.setItem('feedbackButtonHidden', newState.toString());
  };

  const handleOpenFeedback = () => {
    onOpenModal();
  };

  return (
    <>
      {/* Main feedback button */}
      <Collapse in={!isHidden} orientation="horizontal">
        <div className="feedback-button-container">
          <Tooltip title="Send Feedback" placement="left">
            <div className="feedback-button-wrapper">
              <button
                className="feedback-button"
                onClick={handleOpenFeedback}
                aria-label="Send feedback"
              >
                <FeedbackIcon className="feedback-icon" />
                <span className="feedback-text">Feedback</span>
              </button>
              
              {/* Hide button */}
              <IconButton
                className="feedback-hide-button"
                size="small"
                onClick={handleToggleVisibility}
                aria-label="Hide feedback button"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </div>
          </Tooltip>
        </div>
      </Collapse>

      {/* Show button (when hidden) */}
      {isHidden && (
        <Tooltip title="Show Feedback Button" placement="left">
          <IconButton
            className="feedback-show-button"
            onClick={handleToggleVisibility}
            size="small"
            aria-label="Show feedback button"
          >
            <FeedbackIcon />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};

export default FeedbackButton;

